import React from 'react';
import { Outlet } from 'react-router-dom';
import { Header } from '@/components/common/Header';
import { Navigation } from '@/components/common/Navigation';
import { Footer } from '@/components/common/Footer';

export const MainLayout: React.FC = () => {
  return (
    <div className="flex flex-col h-screen overflow-hidden">
      {/* Header - Full width at top */}
      <Header />

      {/* Content Area with Navigation and Main Content */}
      <div className="flex flex-1 overflow-hidden">
        {/* Navigation Sidebar - Vertical */}
        <Navigation />

        {/* Main Content Area */}
        <div className="flex flex-col flex-1 overflow-hidden">
          {/* Page Content */}
          <main className="flex-1 overflow-y-auto bg-gray-50">
            <Outlet />
          </main>

          {/* Footer */}
          <Footer />
        </div>
      </div>
    </div>
  );
};